var map = {
	"./add-icon.svg": "./resources/csmworkflow/img/add-icon.svg",
	"./audit-log-black.svg": "./resources/csmworkflow/img/audit-log-black.svg",
	"./audit-log.svg": "./resources/csmworkflow/img/audit-log.svg",
	"./bell-module.svg": "./resources/csmworkflow/img/bell-module.svg",
	"./bell-regular.svg": "./resources/csmworkflow/img/bell-regular.svg",
	"./brochure.svg": "./resources/csmworkflow/img/brochure.svg",
	"./calendar-green.svg": "./resources/csmworkflow/img/calendar-green.svg",
	"./calendar.svg": "./resources/csmworkflow/img/calendar.svg",
	"./campaign.svg": "./resources/csmworkflow/img/campaign.svg",
	"./chat-bubbles-master-read.svg": "./resources/csmworkflow/img/chat-bubbles-master-read.svg",
	"./chat-bubbles-master-unread.svg": "./resources/csmworkflow/img/chat-bubbles-master-unread.svg",
	"./chat-bubbles-none.svg": "./resources/csmworkflow/img/chat-bubbles-none.svg",
	"./chat-bubbles-read.svg": "./resources/csmworkflow/img/chat-bubbles-read.svg",
	"./chat-bubbles-unread.svg": "./resources/csmworkflow/img/chat-bubbles-unread.svg",
	"./chat-bubbles.svg": "./resources/csmworkflow/img/chat-bubbles.svg",
	"./chevron-down.svg": "./resources/csmworkflow/img/chevron-down.svg",
	"./chevron-up.svg": "./resources/csmworkflow/img/chevron-up.svg",
	"./collapse.svg": "./resources/csmworkflow/img/collapse.svg",
	"./communication-action-plan.svg": "./resources/csmworkflow/img/communication-action-plan.svg",
	"./design.svg": "./resources/csmworkflow/img/design.svg",
	"./dropdown-arrow.svg": "./resources/csmworkflow/img/dropdown-arrow.svg",
	"./dummy-chat.svg": "./resources/csmworkflow/img/dummy-chat.svg",
	"./event.svg": "./resources/csmworkflow/img/event.svg",
	"./expand-menu.svg": "./resources/csmworkflow/img/expand-menu.svg",
	"./expand.svg": "./resources/csmworkflow/img/expand.svg",
	"./external-link-alt-solid.svg": "./resources/csmworkflow/img/external-link-alt-solid.svg",
	"./filter.svg": "./resources/csmworkflow/img/filter.svg",
	"./green-folder.svg": "./resources/csmworkflow/img/green-folder.svg",
	"./green-plus.svg": "./resources/csmworkflow/img/green-plus.svg",
	"./home.svg": "./resources/csmworkflow/img/home.svg",
	"./link-dropbox.svg": "./resources/csmworkflow/img/link-dropbox.svg",
	"./link-file.svg": "./resources/csmworkflow/img/link-file.svg",
	"./link-google-drive.svg": "./resources/csmworkflow/img/link-google-drive.svg",
	"./link-onedrive.svg": "./resources/csmworkflow/img/link-onedrive.svg",
	"./link-teams.svg": "./resources/csmworkflow/img/link-teams.svg",
	"./link-url.svg": "./resources/csmworkflow/img/link-url.svg",
	"./link-web.svg": "./resources/csmworkflow/img/link-web.svg",
	"./logo.svg": "./resources/csmworkflow/img/logo.svg",
	"./logout.svg": "./resources/csmworkflow/img/logout.svg",
	"./magazine.svg": "./resources/csmworkflow/img/magazine.svg",
	"./marketing-project.svg": "./resources/csmworkflow/img/marketing-project.svg",
	"./media-call-nav.svg": "./resources/csmworkflow/img/media-call-nav.svg",
	"./media-call.svg": "./resources/csmworkflow/img/media-call.svg",
	"./media-event.svg": "./resources/csmworkflow/img/media-event.svg",
	"./minus.svg": "./resources/csmworkflow/img/minus.svg",
	"./my-week-list.svg": "./resources/csmworkflow/img/my-week-list.svg",
	"./my-week.svg": "./resources/csmworkflow/img/my-week.svg",
	"./news-release.svg": "./resources/csmworkflow/img/news-release.svg",
	"./organic-social-media.svg": "./resources/csmworkflow/img/organic-social-media.svg",
	"./pencil.svg": "./resources/csmworkflow/img/pencil.svg",
	"./plus.svg": "./resources/csmworkflow/img/plus.svg",
	"./popup-add.svg": "./resources/csmworkflow/img/popup-add.svg",
	"./poster.svg": "./resources/csmworkflow/img/poster.svg",
	"./print-ad.svg": "./resources/csmworkflow/img/print-ad.svg",
	"./project-deliverable-green.svg": "./resources/csmworkflow/img/project-deliverable-green.svg",
	"./project-deliverable-white.svg": "./resources/csmworkflow/img/project-deliverable-white.svg",
	"./project-deliverable.svg": "./resources/csmworkflow/img/project-deliverable.svg",
	"./project-on-hold-icon.svg": "./resources/csmworkflow/img/project-on-hold-icon.svg",
	"./projects-black.svg": "./resources/csmworkflow/img/projects-black.svg",
	"./projects.svg": "./resources/csmworkflow/img/projects.svg",
	"./report-icon.svg": "./resources/csmworkflow/img/report-icon.svg",
	"./report.svg": "./resources/csmworkflow/img/report.svg",
	"./search.svg": "./resources/csmworkflow/img/search.svg",
	"./sm-calendar-placeholder.svg": "./resources/csmworkflow/img/sm-calendar-placeholder.svg",
	"./social-media-post.svg": "./resources/csmworkflow/img/social-media-post.svg",
	"./social-media-white.svg": "./resources/csmworkflow/img/social-media-white.svg",
	"./social-media.svg": "./resources/csmworkflow/img/social-media.svg",
	"./template-editor-icon-light.svg": "./resources/csmworkflow/img/template-editor-icon-light.svg",
	"./template-editor-icon.svg": "./resources/csmworkflow/img/template-editor-icon.svg",
	"./twitter-reply.svg": "./resources/csmworkflow/img/twitter-reply.svg",
	"./twitter-retweet.svg": "./resources/csmworkflow/img/twitter-retweet.svg",
	"./twitter.svg": "./resources/csmworkflow/img/twitter.svg",
	"./undo.svg": "./resources/csmworkflow/img/undo.svg",
	"./up-down.svg": "./resources/csmworkflow/img/up-down.svg",
	"./web-project.svg": "./resources/csmworkflow/img/web-project.svg",
	"./website.svg": "./resources/csmworkflow/img/website.svg",
	"./white-folder.svg": "./resources/csmworkflow/img/white-folder.svg",
	"./writing-assignment.svg": "./resources/csmworkflow/img/writing-assignment.svg",
	"./year-calendar-tooltip.svg": "./resources/csmworkflow/img/year-calendar-tooltip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/csmworkflow/img sync recursive ^\\.\\/.*\\.svg$";